import { h, render } from 'preact';
import reduce from 'lodash/reduce';
import BasketSummary from './BasketSummary';
import { ExternalBasket } from '../types';

declare global {
    interface Window {
        __BASKET__: ExternalBasket;
    }
}

export default function(container: HTMLDivElement) {
    const totalItems = reduce(window.__BASKET__.items, (sum, item, sku) => sum + item.quantity, 0);

    container.innerHTML = '';
    const checkoutDisabled = container.dataset.checkoutDisabled === '1';

    render(<BasketSummary
        defaultTotalItems={totalItems}
        defaultSubTotalExcludingSurcharges={window.__BASKET__.subtotal_excluding_surcharges}
        defaultAmountUntilFreeDelivery={window.__BASKET__.amount_until_free_delivery}
        defaultHasWarnings={window.__BASKET__.errors.length > 0 || window.__BASKET__.surcharges.length > 0}
        checkoutDisabled={checkoutDisabled}
    />, container);
};
